<template>

  <div>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg ">

        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Book Now</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="row justify-content-center mt--100">
          <div class="col-lg-12">
            <card gradient="white" shadow>
              <div class="iframe-container">
                <iframe ref="iframeElement" src="https://offthecouch.io/book/otc" :style="{ height: iframeHeight + 'px' }"
                          frameborder="0" allowfullscreen></iframe>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "BookNow",
  data () {
    return {
      iframeHeight: 100
    }
  },
  methods: {
    handleMessage(event) {
      if (event.origin === 'https://offthecouch.io') {
        this.iframeHeight = event.data.height;
      }
    }
  },
  mounted(){
    window.addEventListener('message', this.handleMessage);
  }
}
</script>

<style scoped>
.iframe-container{
  overflow: hidden;
}
iframe {
  width: 100%; /* or the exact width of the content */
  height: 100px;
  border-radius: 5px;
}
</style>
